
import { useState, useEffect } from 'react';

export const useCookieConsent = () => {
  const [consent, setConsent] = useState({
    necessary: false,
    analytics: false,
    marketing: false,
    functional: false
  });
  
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem('trbe-cookie-consent');
    if (savedConsent) {
      try {
        const parsed = JSON.parse(savedConsent);
        setConsent(parsed);
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
      }
    }
    setIsLoaded(true);
  }, []);

  const updateConsent = (newConsent) => {
    setConsent(newConsent);
    localStorage.setItem('trbe-cookie-consent', JSON.stringify(newConsent));
    localStorage.setItem('trbe-cookie-consent-timestamp', Date.now().toString());
  };

  const hasConsent = (type) => {
    return consent[type] === true;
  };

  const withdrawConsent = () => {
    localStorage.removeItem('trbe-cookie-consent');
    localStorage.removeItem('trbe-cookie-consent-timestamp');
    localStorage.removeItem('trbe-cookie-consent-log');
    
    setConsent({
      necessary: false,
      analytics: false,
      marketing: false,
      functional: false
    });
    
    // Reload page to reset all tracking
    window.location.reload();
  };

  return {
    consent,
    isLoaded,
    hasConsent,
    updateConsent,
    withdrawConsent
  };
};
